import { render, staticRenderFns } from "./SideBarContainer.vue?vue&type=template&id=adc8a004&"
import script from "./SideBarContainer.vue?vue&type=script&lang=js&"
export * from "./SideBarContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports